import { render, staticRenderFns } from "./SavedSignatures.vue?vue&type=template&id=5f462a4e&scoped=true"
import script from "./SavedSignatures.vue?vue&type=script&lang=ts"
export * from "./SavedSignatures.vue?vue&type=script&lang=ts"
import style0 from "./SavedSignatures.vue?vue&type=style&index=0&id=5f462a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f462a4e",
  null
  
)

export default component.exports